// One shared signature block used by generated documents. Renders the resolved
// authorized-rep signature image above a line, with printed name, title and the
// document's generation date. When no signature resolves, it renders the blank
// line exactly as before — never breaking or shifting the layout.
//
// The image is always a data URI embedded server-side at render time, so it
// cannot fail to load in a PDF renderer or email client. This component is used
// ONLY for authorized-rep lines; customer lines never receive a `signature`.
export default function RepSignature({
  signature,          // { image, printed_name, title } or null/undefined
  label = "Authorized signature",
  date = "",
  nameFallback = "",
  className = "",
  light = true,       // document background is light
}) {
  const img = signature?.image;
  const printed = signature?.printed_name || nameFallback || "";
  const title = signature?.title || "";
  const textColor = light ? "#334155" : "#e5e7eb";
  const lineColor = light ? "#334155" : "#9ca3af";
  return (
    <div className={className} data-testid="rep-signature-block">
      <div style={{ height: 40, display: "flex", alignItems: "flex-end" }}>
        {img ? (
          <img src={img} alt="Authorized signature" style={{ maxHeight: 40, maxWidth: "100%", objectFit: "contain", display: "block" }} data-testid="rep-signature-image" />
        ) : null}
      </div>
      <div style={{ borderTop: `1px solid ${lineColor}`, paddingTop: 4 }}>
        <div style={{ fontSize: 11, color: textColor }}>{label}</div>
        {printed ? <div style={{ fontSize: 12, fontWeight: 600, color: textColor }}>{printed}</div> : null}
        {title ? <div style={{ fontSize: 10, color: textColor, opacity: 0.8 }}>{title}</div> : null}
        {date ? <div style={{ fontSize: 10, color: textColor, opacity: 0.7 }}>{date}</div> : null}
      </div>
    </div>
  );
}
